export const applicationCountries = {
  fr: '🇫🇷',
  be: '🇧🇪',
  it: '🇮🇹',
  nl: '🇳🇱',
  de: '🇩🇪',
} as const
